import { createSignal } from "solid-js"
import { deepClone } from "../../lib/deep_clone"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"
import type { State } from "../../lib/core/state/State.type"

export const useEnginePrevStateSignal = createSharedCachedFactory((engine) => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<State>(deepClone(engine.state))

  return signal
})
